import { gql } from '@apollo/client';

export * from './completeSecureUpload.mutation.generated';

export const SECURE_UPLOAD_COMPLETE = gql`
  mutation secureUploadComplete(
    $softwareEscrowId: ID!
    $uploadId: String!
    $filename: String!
    $parts: [SecureUploadPartParams!]!
    $size: BigInt!
    $contentType: AssetContentTypeEnum!
  ) {
    secureUploadComplete(
      input: {
        softwareEscrowId: $softwareEscrowId
        uploadId: $uploadId
        filename: $filename
        parts: $parts
        size: $size
        contentType: $contentType
      }
    ) {
      success
      errors
      asset {
        id
        depositStatus
      }
    }
  }
`;
